import { add } from "date-fns/add";

import { PaceAnswers } from "@/types/answers";

import { factors, FactorType } from "./factors";

export const FOUR_WEEKS_DAYS_AMOUNT = 7 * 4;

export const getPredictionDate = (
    currentWeight: number,
    targetWeight: number,
    pace: PaceAnswers,
    factorType: FactorType
) => {
    const factor = factors[factorType];
    const weeklyFactor = factor[pace];
    const weightToLose = currentWeight - targetWeight;
    const daysAmountToLose = (weightToLose / weeklyFactor) * 7;

    const predictDate = add(new Date(), { days: daysAmountToLose });
    return predictDate;
};

export const getDaysDiff = (date1: Date, date2: Date): number =>
    Math.round((date1.getTime() - date2.getTime()) / (1000 * 3600 * 24));

export const getPredictionWeightLoss = (date: Date, pace: PaceAnswers, factorType: FactorType) => {
    const factor = factors[factorType];
    const weeklyFactor = factor[pace];
    const nowDate = new Date();
    const daysAmount = getDaysDiff(date, nowDate);
    const weeksAmount = daysAmount / 7;
    const predictWeight = weeksAmount * weeklyFactor;

    return predictWeight;
};

export const getDateInFourWeeks = () => {
    const date = new Date();
    date.setDate(date.getDate() + FOUR_WEEKS_DAYS_AMOUNT);

    return date;
};
